import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { appOffline, appOnline } from '../actions/appState';

import OfflineBanner from '../components/OfflineBanner/OfflineBanner';

const mapStateToProps = state => {
  return {
    isOffline: state.appStatus.isOffline,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      appOffline,
      appOnline,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(OfflineBanner);
